import React, { useEffect, useState, useRef } from "react";
import HttpService from "../../services/httpService";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { connect } from "react-redux";
import { Dialog, DialogContent, DialogTitle, FormControl, Box, TextField, IconButton, DialogActions, Divider, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';
import { Button as MuiButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { setMeetingTrack } from "../../redux/actions/leadSourceActions";
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import { useDispatch } from 'react-redux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from "@material-ui/core/Grid";
import Tooltip from '@material-ui/core/Tooltip';
import { DownloadOutlined } from '@ant-design/icons';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    withStyles,
    TableContainer
} from "@material-ui/core";
import { Button } from "antd";
import { Modal } from "antd";
import { CSVLink } from "react-csv";
import moment from "moment";
import { ROLENAME } from '../../utils/index';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import { EyeFilled } from '@ant-design/icons';
import CloseIcon from '@material-ui/icons/Close';
import RefreshIcon from '@material-ui/icons/Refresh';
import ProposedMeetingPage from "../proposedMeetingDashboard";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        '& > * + *': {
            marginTop: theme.spacing(2),
        },
    },
    bordercolors: {
        border: '1px solid #eee5e5',
        background: "#1C375D",
        color:'white'
    },
    table: {
        minWidth: 700,
    },
    root: {
        width: '100%',
    },
    title: {
        fontSize: 14,
    },
    customTableContainer: {
        overflowX: "initial"
    },
    pos: {
        marginBottom: 12,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginpivotRight: theme.spacing(1),
        width: 200,
    },
    table: {
        width: "fit-content",
    },
    csv: {
        display: "flex",
        alignItems: "center",
        marginBottom: 20,
    },
    report: {
        marginBottom: 20,
        alignItems: "center",
        justifyContent: "center",
    },
    leadSearchButton: {
        backgroundColor: '#FDB913',
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
        "&:hover": { backgroundColor: "#14419c", color: 'white' }
    },
    leadClearButton: {
        backgroundColor: '#f7b7b7', // light red background
        color: '#151921',
        padding: '1',
        marginRight: '0.5em',
        borderRadius: '20px',
        width: '20%',
    },
    submitButton: {
        backgroundColor: '#F47E46 !important',  // Decorpot Orange
        color: 'white',            // White text
        '&:hover': {
          backgroundColor: '#E0663D !important', // Darker Orange on hover
        },
    },
    tableHeaderCell: {
        backgroundColor: '#f0f8ff',
        fontWeight: 'bold',
    },
    dialogRoot: {
        zIndex: '10000 !important',
    },
}));

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: "#1C375D",
        color:'white',
        fontWeight: "500",
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);


const MeetingTrackerDashboard = (props) => {
    const classes = useStyles();
    const { userDetails } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const meetingData = useSelector((state) => state.leadSource.meetingTracker);
    const [meetingTrackerDashboardType, setMeetingTrackerDashboardType ] = useState('Meeting Done');
    const [store, setStore] = useState([]);
    const [storeDateFilter, setPivotDatefilters] = useState({ startDate: "", endDate: "" });
    const [selectedValue, setSelectedValue] = useState("");
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [csvData, setCsvData] = useState([]);
    const csvButtonRef = useRef(null);
    const [popMonthData, setPopMonthData] = useState([]);
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [selectLost, setSeletLost] = useState('')
    const [searchInput, setSearchInput] = useState("")
    const [selectedSearchType, setSelectedSearchType] = useState("");
    const searchTypes = ['Customer Name', 'Email ID', 'Lead No', 'Project No', 'Contact No', 'Unique Lead No']
    const [notesVisibility, setNotesVisibility] = useState(false)
    const [latestNotes, setLatestNotes] = useState([])
    const [leadNo, setLeadNo] = useState("");
    const [showMeetingLogs, SetShowMeetingLogs] = useState(false);
    const [meetingLogs, setMeetingLogs] = useState([]);
    const [lastLeadIdForLogs, setLastLeadIdForLogs] = useState(null);
    const [clickBasedlog, SetClickBasedLog] = useState();
    const [isSpinning, setIsSpinning] = useState(false);
    const FORTH_BUTTON_DISABLE_UNTIL_KEY = 'forthButton_disableUntil';
    const [isDisabled, setIsDisabled] = useState(false);
    const [shouldRefresh, setShouldRefresh] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);
    const [meetingDatecount, setMeetingDatecount] = useState([]);
    const [meetingExpcenter, setmeetingExpcenter] = useState([]);
    const [meetingExpcenterGrandTotal, setmeetingExpcenterGrandTotal] = useState(0);
    const [meetingExpcenterGrandTotalLeadId, setmeetingExpcenterGrandTotalLeadId] = useState(0);
    const [meetingTrackerTableCsvData, setMeetingTrackerTableCsvData] = useState([]);
    const meetingTrackerTableCsvButtonRef = useRef(null);
    const [meetingTrackerMonthlyTableCsvData, setMeetingTrackerMonthlyTableCsvData] = useState([]);
    const meetingTrackerMonthlyTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    const [triggerMonthlyDownload, setTriggerMonthlyDownload] = useState(false);

    const [sourceOfLeadData, setSourceOfLeadData] = useState([]);
    const [selectedLeadSource, setSelectedLeadSource] = useState([]);
    
    const [selectedLocation, setSelectedLocation] = useState([])
    const [commonLocation, setLocation] = useState([])
    const [commonExpCenter, setExpCenter] = useState([])
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([])
    const handleMultipleExpData = (e, newvalue) => {
        setSelectedExperienceCenter(newvalue)
    }
    const expCenters = async () => {
        props.setLoading(true);
        try {
            let response = await HttpService.getExpericenCenters();
            const matchedUsers = response.data.filter(user => {
                return userDetails.experienceCenterId.includes(user._id);
            });
            setExpCenter(matchedUsers)
        } catch (error) {
            console.error("Error fetching experience centers:", error);
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }
    const handleMultipleLocationData = (e, newValue) => {
        setSelectedLocation(newValue)
    }
    
     const locations = async () => {
            props.setLoading(true);
            try {
                let response = await HttpService.getLocation();
                const matchedUsers = response.data.filter(user => {
                    return userDetails.selectedLocation.includes(user._id);
                });
                setLocation(matchedUsers)
            } catch (error) {
                console.error("Error fetching experience centers:", error);
                props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
            }
            props.setLoading(false);
    }

    const getSourceOfLeadData = async () => {
        try {
            const users = await HttpService.getLeadMaster();
            setSourceOfLeadData(users.data || []);
        } catch (error) {
            console.error('Error fetching source of lead data:', error);
            props.setSnackInfo('Error loading source of lead data', "error");
        }
    };

    useEffect(() => {
        setTimeout(() => {
            meetingTrackerData(selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput,'',selectedLocation);
            DataBasedDateMeetingTracker(storeDateFilter,"",selectedLocation,selectedExperienceCenter);
        }, 10);
       }, [selectedLocation,selectedExperienceCenter])

    useEffect(() => {
        getSourceOfLeadData();
        locations();
        expCenters();
    }, []);

    useEffect(() => {
        if ((userDetails.roles.find(role => role.name === ROLENAME.AssistantSalesManager))) {
            meetingTrackerData()
            DataBasedDateMeetingTracker(storeDateFilter)
            setSelectedRole(ROLENAME.AssistantSalesManager)
        } else if ((userDetails.roles.find(role => role.name === ROLENAME.SalesUser))) {
            meetingTrackerData()
            DataBasedDateMeetingTracker(storeDateFilter)
            setSelectedRole(ROLENAME.SalesUser)
        } else {
            meetingTrackerData()
            DataBasedDateMeetingTracker(storeDateFilter)
            setSelectedRole("ALL")
        }
    }, []);

    const headers = [
        { key: "serialNo", label: "Sl. No." },
        { key: "projectCode", label: "Project No." },
        { key: "leadNumber", label: "Lead No." },
        { key: "clientName", label: "Client Name" },
        { key: "sourceOfLead", label: "Source of Lead" },
        { key: "totalValue", label: "Value (INR)" },
        { key: "expCtrName", label: "Exp. Ctr Name" },
        { key: "currentStage", label: "Current Stage" },
        { key: "leadWonDate", label: "Sales Won Date" },
        { key: "meetingType", label: "Meeting Type" },
        { key: "meetingDateTime", label: "Meeting Date" },
        { key: "leadCreatedDate", label: "Lead Created Date" },
        { key: "leadAssignedDate", label: "Lead Assigned Date" },
        { key: "salesExecutive", label: "Sales Executive" },
        { key: "asm", label: "ASM" },
        { key: "meetingLog", label: "Meeting Log" },
        { key: "quotationOpenCount", label: "Total Count Quotation Open by Cx" },
    ];

    const csvDownloadHandler = async (data) => {
        setLoading(true);
        try {
            let csvArray = [];
            for (let i = 0; i < popMonthData.length; i++) {
                const data = popMonthData[i];
            
                // Extract data with proper fallbacks (check both data and data.leadId)
                const leadId = data?.leadId || {};
                const customerId = leadId?.customerId || data?.customerId || {};
                const sourceOfLead = leadId?.sourceOfLead || data?.sourceOfLead || {};
                const experienceCenterId = leadId?.experienceCenterId || data?.experienceCenterId || {};
                const salesUser = leadId?.salesUser || data?.salesUser || {};
                const salesAssistantManager = leadId?.salesAssistantManager || data?.salesAssistantManager || {};
                
                let obj = {
                    serialNo: i + 1,
                    projectCode: leadId?.erpProjectNo || data?.erpProjectNo || "N/A",
                    leadNumber: leadId?.lead_no || data?.lead_no || "N/A",
                    clientName: customerId?.name || "N/A",
                    sourceOfLead: sourceOfLead?.name || "N/A",
                    totalValue: leadId?.staticSalesWonBudget || data?.staticSalesWonBudget 
                    ? leadId?.staticSalesWonBudget || data?.staticSalesWonBudget : 0,
                    expCtrName: experienceCenterId?.name || "N/A",
                    currentStage: leadId?.currentStage || data?.currentStage || "N/A",
                    leadWonDate: leadId?.leadWonDate || data?.leadWonDate 
                        ? moment(leadId?.leadWonDate || data?.leadWonDate).format("DD-MM-YYYY")
                        : "N/A",
                    meetingType: data?.meetingType || "N/A",
                    meetingDateTime: data?.meetingDate 
                        ? moment(data?.meetingDate).format("DD-MM-YYYY")
                        : "N/A",
                    leadCreatedDate: leadId?.createdAt || data?.createdAt
                        ? moment(leadId?.createdAt || data?.createdAt).format("DD-MM-YYYY")
                        : "N/A",
                    leadAssignedDate: leadId?.leadAssignedDate || data?.leadAssignedDate
                        ? moment(leadId?.leadAssignedDate || data?.leadAssignedDate).format("DD-MM-YYYY")
                        : "N/A",
                    salesExecutive: salesUser?.name || "N/A",
                    asm: salesAssistantManager?.name || "N/A",
                    meetingLog: leadId?.meetingLogsCount || data?.meetingLogsCount || "N/A",
                    quotationOpenCount: leadId?.quotationOpenCount ?? data?.quotationOpenCount ?? 0,
                };
                csvArray.push(obj);
                // obj = {
                //     serialNo: "",
                //     projectCode: "",
                //     clientName: "",
                //     totalValue: "",
                //     expCtrName: "",
                //     currentStage: "",
                //     salesWonDate: "",
                //     meetingType: "",
                //     meetingDateTime: "",
                //     leadCreatedDate: "",
                //     salesExecutive: "",
                //     asm: ""
                // };
                // csvArray.push(obj);
            }
            setCsvData(csvArray);
            downloadExcel();
        } catch (error) {
            console.log("error", error);
            props?.setSnackInfo(
                error?.response?.data?.message ?? "Something went wrong",
                "error"
            );
        }
        setLoading(false);
    };

    const downloadExcel = () => {
        setLoading(true);
        try {
            setTimeout(() => {
                csvButtonRef.current.link.click();
            });
        } catch (err) {
            console.error(err.message);
        }
        setLoading(false);
    };
    const expCenterData = {};
    store.forEach((el) => {
        if (!expCenterData[el.experienceCenterName]) {
            expCenterData[el.experienceCenterName] = [];
        }
        expCenterData[el.experienceCenterName].push(el);
    });
    const uniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));
    let uniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));


    const meetingTrackerData = async (addExpCenter, usersData, selectedSearchType, searchInput, sourceOfLeadOverride = null,addLocation) => {
        let expCenterData = addExpCenter?.map((el) => el._id)
        let locationData = addLocation?.map((el) => el._id)
        let users = ''
        if ((usersData?.users && usersData?.users.length !== 0) || (selectedUsers && selectedUsers.length !== 0)) {
            users = usersData?.users?.map((el) => el._id) || selectedUsers?.map((el) => el._id)
        }
        let obj = {
            startDate: storeDateFilter.startDate,
            endDate: storeDateFilter.endDate,
            selectedExperienceCenter: expCenterData ? expCenterData : "",
            selectedlocation: locationData ? locationData : "",
            tokenPercentage: selectedValue !== "" ? selectedValue : "",
            users: users ? users : "",
            userExpCenter: userDetails.experienceCenterId,
            lost: selectLost !== "" ? selectLost : "",
            pivotValue: 'meetingTracker',
            searchType: selectedSearchType ? selectedSearchType : "",
            search: searchInput ? searchInput.toUpperCase() : ""
        }
        const leadSourceToUse = sourceOfLeadOverride !== null ? sourceOfLeadOverride : selectedLeadSource;
        if (leadSourceToUse && leadSourceToUse.length !== 0) {
            obj.sourceOfLead = leadSourceToUse.map(source => source._id);
        }
        
        if (userDetails.roles.find(role => role.name === ROLENAME.AssistantSalesManager)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.AssistantSalesManager
        } else if (userDetails.roles.find(role => role.name === ROLENAME.SalesUser)) {
            obj.selectedRole = usersData?.role ? usersData?.role : ROLENAME.SalesUser
        } else {
            obj.selectedRole = usersData?.role ? usersData?.role : (selectedRole ? selectedRole : "ALL")
        }
        props.setLoading(true);
        try {
            // if( !meetingData  ||  meetingData === null){
            let response = await HttpService.getMeetingTrackerBasedOnUserExpCenter(obj);
            setStore(response.data);
            setMeetingTrack(response.data);
            // }else{
            //     setStore(meetingData)
            // }
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }

        props.setLoading(false);
    }
    // getDataBasedDateMeetingTracker
    const DataBasedDateMeetingTracker = async (storeDateFilter, sourceOfLeadOverride = null,locationData,ExperienceCenterData) => {
        props.setLoading(true);
        try {
            let selectedLocation = locationData?.map((el) => el._id)
            let selectedExpCenter = ExperienceCenterData?.map((el) => el._id)
            let filterObj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedLocation:selectedLocation,
                selectedExperienceCenter:selectedExpCenter
            };
            // Use override value if provided, otherwise use state
            const leadSourceToUse = sourceOfLeadOverride !== null ? sourceOfLeadOverride : selectedLeadSource;
            // Add sourceOfLead filter if selected
            if (leadSourceToUse && leadSourceToUse.length !== 0) {
                filterObj.sourceOfLead = leadSourceToUse.map(source => source._id);
            }
            let response = await HttpService.getDataBasedDateMeetingTracker(filterObj);
            setMeetingDatecount(response.data.data.dayWiseTotals)
            setmeetingExpcenter(response.data.data.experienceCenters)
            setmeetingExpcenterGrandTotal(response.data.data.grandTotal)
            setmeetingExpcenterGrandTotalLeadId(response.data.data.allLeadIds)
            // console.log(response.data.data.grandTotal)
           
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }

        props.setLoading(false);
    }


    const formatNumberToTwoDecimalPlaces = (value) => {
        return Math.floor(parseFloat(value));
    };
    

    const storePivotDate = (e) => {
        const { name, value } = e.target
        setPivotDatefilters({ ...storeDateFilter, [name]: value })
    }
    const handlePivotDateFilter = () => {
        meetingTrackerData(selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput,selectedLocation)
        DataBasedDateMeetingTracker(storeDateFilter,selectedLeadSource,selectedLocation,selectedExperienceCenter)
    }
    const handleSearchType = (value) => {
        setSelectedSearchType(value)
        setSearchInput('')
    }
    const handleSearch = async (value) => {
        meetingTrackerData(selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput,selectedLocation)
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' && selectedSearchType && searchInput) {
            handleSearch(searchInput.toUpperCase());
        }
    };
    

    const getDataBasedOnClickMeetingTracker = async (e, month, innerEl, val, particularName) => {
        let obj = {}
        let users = ''
        let expCenterData =
            selectedExperienceCenter && selectedExperienceCenter.length > 0
                ? selectedExperienceCenter.map((el) => el._id)
                : "";
        if (selectedUsers && selectedUsers.length !== 0) {
            users = selectedUsers?.map((el) => el._id)
        }
        if (val === 'meetingTracker') {
            obj = {
                _id: { month: month.monthNumber, year: month.year },
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedExperienceCenter: innerEl.experienceCenterId ? innerEl.experienceCenterId : expCenterData,
                tokenPercentage: selectedValue !== "" ? selectedValue : "",
                lost: selectLost !== "" ? selectLost : "",
                pivotValue: 'meetingTracker',
                selectedRole: selectedRole ? selectedRole : "",
                userExpCenter: userDetails.experienceCenterId,
                users: users ? users : "",
                particularName: particularName,
                searchType: selectedSearchType ? selectedSearchType : "",
                search: searchInput !== "" ? searchInput.toUpperCase() : ""
            }
            if (selectedLeadSource && selectedLeadSource.length !== 0) {
                obj.sourceOfLead = selectedLeadSource.map(source => source._id);
            }
        } else if (val === 'total') {
            if (innerEl === "Grand Total") {
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenterData,
                    startDate: storeDateFilter?.startDate,
                    endDate: storeDateFilter?.endDate,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'meetingTracker',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    users: users ? users : "",
                    particularName: particularName,
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : ""
                }
                if (selectedLeadSource && selectedLeadSource.length !== 0) {
                    obj.sourceOfLead = selectedLeadSource.map(source => source._id);
                }
            } else {
                let expCenter;
                for (let i = 0; i < store.length; i++) {
                    if (store[i].experienceCenterName === innerEl) {
                        expCenter = store[i].experienceCenterId
                        break;
                    }
                }
                obj = {
                    _id: { startMonth: month[0].monthNumber, startYear: month[0].year, endtMonth: month[month.length - 1].monthNumber, endtYear: month[month.length - 1].year },
                    selectedExperienceCenter: expCenter,
                    startDate: storeDateFilter?.startDate,
                    endDate: storeDateFilter?.endDate,
                    tokenPercentage: selectedValue !== "" ? selectedValue : "",
                    lost: selectLost !== "" ? selectLost : "",
                    pivotValue: 'meetingTracker',
                    selectedRole: selectedRole ? selectedRole : "",
                    userExpCenter: userDetails.experienceCenterId,
                    users: users ? users : "",
                    particularName: particularName,
                    searchType: selectedSearchType ? selectedSearchType : "",
                    search: searchInput !== "" ? searchInput.toUpperCase() : ""
                }
                if (selectedLeadSource && selectedLeadSource.length !== 0) {
                    obj.sourceOfLead = selectedLeadSource.map(source => source._id);
                }
            }
        }
        props.setLoading(true);
        try {
            SetClickBasedLog(obj)
            let response = await HttpService.getDataBasedClickMeetingTracker(obj);
            setPopMonthData(response.data)
            setShowDetailedModal(true)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }
    const getDataBasedClickMeetingTrackerCount = async (leadIds) => {
        props.setLoading(true);
        try {
            let obj = {"leadIds":leadIds}
            // Add sourceOfLead filter if selected
            if (selectedLeadSource && selectedLeadSource.length !== 0) {
                obj.sourceOfLead = selectedLeadSource.map(source => source._id);
            }
            let response = await HttpService.getDataBasedClickMeetingTrackerCount(obj);
            setPopMonthData(response?.data?.data)
            setShowDetailedModal(true)
        } catch (error) {
            props.setSnackInfo(error?.response?.data ?? "Something Went Wrong", "error")
        }
        props.setLoading(false);
    }

    const handleViewNotes = (notes, lead_no) => {
        setNotesVisibility(true)
        setLatestNotes(notes)
        setLeadNo(lead_no)
    }

    const clearDateFilter = () => {
        setSearchInput("")
        setSelectedSearchType("")
        setSelectedLeadSource([])
        // dispatch(setMeetingTrack(null))
        setShouldRefresh(true) // Trigger the useEffect
        meetingTrackerData(selectedExperienceCenter, selectedUsers, "", "","")
        setPivotDatefilters({ startDate: "", endDate: "" })
        let dateObj = { startDate: "", endDate: "" }
        DataBasedDateMeetingTracker(dateObj,"")
    }

    // useEffect(() => {
    //     // Check if there's a stored disable time in localStorage
    //     const disableUntilTimestamp = localStorage.getItem(FORTH_BUTTON_DISABLE_UNTIL_KEY);
        
    //     if (disableUntilTimestamp) {
    //         const now = new Date().getTime();
    //         const disableUntil = parseInt(disableUntilTimestamp, 10);
            
    //         // If the disable time is in the future, calculate remaining time
    //         if (disableUntil > now) {
    //         const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
    //         setTimeLeft(remainingTimeInSeconds);
    //         setIsDisabled(true);
    //         } else {
    //         // If the time has passed, clear localStorage
    //         localStorage.removeItem(FORTH_BUTTON_DISABLE_UNTIL_KEY);
    //         setIsDisabled(false);
    //         setTimeLeft(0);
    //         }
    //     }
        
    //     // Set up timer to update remaining time
    //     let timer;
    //     if (isDisabled && timeLeft > 0) {
    //         timer = setInterval(() => {
    //         setTimeLeft(prevTime => {
    //             const newTime = prevTime - 1;
    //             if (newTime <= 0) {
    //             // When time is up, clear localStorage and enable button
    //             localStorage.removeItem(FORTH_BUTTON_DISABLE_UNTIL_KEY);
    //             setIsDisabled(false);
    //             return 0;
    //             }
    //             return newTime;
    //         });
    //         }, 1000);
    //     }
        
    //     return () => clearInterval(timer);
    //     }, [isDisabled, timeLeft]);
    
        useEffect(() => {
            // if (shouldRefresh && meetingData === null) {
                meetingTrackerData(selectedExperienceCenter, selectedUsers, "", "","")
                // setShouldRefresh(false)
            // }
        }, [])
    
        // Format time for display
        // const formatTimeLeft = () => {
        // const minutes = Math.floor(timeLeft / 60);
        // const seconds = timeLeft % 60;
        // return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        // };
    
        // Replace your existing handleRefreshClick with this
        // const handleRefreshClick = () => {
        // // Calculate the timestamp 4 minutes from now
        // const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);
        
        // // Store the timestamp in localStorage
        // localStorage.setItem(FORTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());
        
        // // Disable the button for 4 minutes
        // setIsDisabled(true);
        // setTimeLeft(10); // 4 minutes in seconds
        
        // // Run the original functionality
        // setIsSpinning(true);
        // clearDateFilter();
        // setTimeout(() => {
        //     setIsSpinning(false);
        // }, 1000);
        // };
    
        useEffect(() => {
            // if (shouldRefresh && meetingData === null) {
                meetingTrackerData(selectedExperienceCenter, selectedUsers, "", "")
                // setShouldRefresh(false)
            // }
        }, [])
    
        // Add this effect to initialize state from localStorage and handle timer
        useEffect(() => {
            // Check if there's a stored disable time in localStorage
            const disableUntilTimestamp = localStorage.getItem(FORTH_BUTTON_DISABLE_UNTIL_KEY);
    
            if (disableUntilTimestamp) {
                const now = new Date().getTime();
                const disableUntil = parseInt(disableUntilTimestamp, 10);
    
                // If the disable time is in the future, calculate remaining time
                if (disableUntil > now) {
                    const remainingTimeInSeconds = Math.ceil((disableUntil - now) / 1000);
                    setIsDisabled(true);
                    setTimeLeft(remainingTimeInSeconds);
                } else {
                    // If the time has passed, clear localStorage
                    localStorage.removeItem(FORTH_BUTTON_DISABLE_UNTIL_KEY);
                    setIsDisabled(false);
                    setTimeLeft(0);
                }
            }
    
            // Set up timer to update remaining time
            let timer;
            if (isDisabled && timeLeft > 0) {
                timer = setInterval(() => {
                    setTimeLeft((prevTime) => {
                        const newTime = prevTime - 1;
                        if (newTime <= 0) {
                            // When time is up, clear localStorage and enable button
                            localStorage.removeItem(FORTH_BUTTON_DISABLE_UNTIL_KEY);
                            setIsDisabled(false);
                            return 0;
                        }
                        return newTime;
                    });
                }, 1000);
            }
    
            return () => clearInterval(timer);
        }, [isDisabled, timeLeft]);
    
        // Format time for display
        const formatTimeLeft = () => {
            const minutes = Math.floor(timeLeft / 60);
            const seconds = timeLeft % 60;
            return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
        };
    
        const handleRefreshClick = async () => {
            // Calculate the timestamp 4 minutes from now
            const disableUntilTimestamp = new Date().getTime() + (4 * 60 * 1000);
    
            // Store the timestamp in localStorage
            localStorage.setItem(FORTH_BUTTON_DISABLE_UNTIL_KEY, disableUntilTimestamp.toString());
    
            // Disable the button for 4 minutes
            setIsDisabled(true);
            setTimeLeft(240); // 4 minutes in seconds
    
            props.setLoading(true);
            try {
                // Refresh date-based table
                if (storeDateFilter.startDate && storeDateFilter.endDate) {
                    await DataBasedDateMeetingTracker(storeDateFilter);
                }
                // Refresh monthly table
                await meetingTrackerData(selectedExperienceCenter, { users: selectedUsers, role: selectedRole }, selectedSearchType, searchInput,selectedLocation);
                props.setSnackInfo('All tables refreshed successfully', "success");
            } catch (error) {
                props.setSnackInfo('Error refreshing tables', "error");
                console.error('Error refreshing tables:', error);
            } finally {
                props.setLoading(false);
            }
        };

    const handleOpenViewMeetingsLogs = async (leadId) => {
        SetShowMeetingLogs(true);
        // Store the leadId for refresh functionality
        setLastLeadIdForLogs(leadId);
        
        try {
            const response = await HttpService.getDataForMeetingTracket(leadId?.leadId?._id ||leadId?._id );
            const data = response?.data;

            if(!leadId?.leadId?._id && leadId?._id ){
                setMeetingLogs(data?.meetingLogs);
                return 
            }
            if (data?.success) {
                const targetMonth = clickBasedlog?._id?.startMonth;
                const targetYear = clickBasedlog?._id?.startYear;
                // Extract start and end dates for the range from clicked data
                const startDate = new Date(clickBasedlog?.startDate || "2000-01-01"); // Default to a very early date if empty
                const endDate = new Date(clickBasedlog?.endDate || "2100-12-31"); // Default to a very late date if empty

                // Also, get start and end years from the clicked data
                const startYear = clickBasedlog?._id?.startYear;
                const endYear = clickBasedlog?._id?.endtYear;

                const targetMonthSingle = clickBasedlog?._id?.month;
                const targetYearSingle = clickBasedlog?._id?.year;
    
                // Filter meetings based on particularName and date
                // if(targetMonth && targetYear && startYear && endYear) {
                    const filteredMeetings = data?.meetingLogs?.filter(meeting => {
                        const meetingDate = new Date(meeting?.meetingDate);
                        const meetingMonth = meetingDate?.getMonth() + 1; // 0-indexed, so add 1
                        const meetingYear = meetingDate?.getFullYear();
        
                        // Check if the meeting is in the target month/year
                        const isTargetMonthYear = meetingMonth === targetMonth && meetingYear === targetYear;
                        const isWithinRange = meetingDate >= startDate && meetingDate <= endDate;
                        const isWithinYearRange = meetingYear >= startYear && meetingYear <= endYear;
        
                        switch (clickBasedlog?.particularName) {
                            case "NoOfMeeting":
                                return (isTargetMonthYear || isWithinRange || isWithinYearRange);
        
                            case "WonFromMeeting":
                                return (isTargetMonthYear || isWithinRange || isWithinYearRange);

                            case "NotWonNotLost":
                                return (isTargetMonthYear || isWithinRange || isWithinYearRange);

                            default:
                                return false;
                        }
                    });  
                    setMeetingLogs(filteredMeetings);
                // } else {
                //     const filteredMeetings = data?.meetingLogs?.filter(meeting => {
                //         const meetingDate = new Date(meeting?.meetingDate);
                //         const isTargetMonth = meetingDate?.getMonth() + 1 === targetMonthSingle && 
                //                 meetingDate?.getFullYear() === targetYearSingle;
                        
                //         switch (clickBasedlog?.particularName) {
                //             case "NoOfMeeting":
                //                 return isTargetMonth;
                                
                //             case "WonFromMeeting":
                //                 return isTargetMonth;

                                
                //             case "NotWonNotLost":
                //                 return isTargetMonth;

                //             default:
                //                 return false;
                //         }
                //     });
                //     setMeetingLogs(filteredMeetings);
                // }
            }
        } catch (error) {
            console.error("error", error);
        }
    };

    const handleRefreshModalTable = async () => {
        if (clickBasedlog?.leadIds && clickBasedlog.leadIds.length > 0) {
            await getDataBasedClickMeetingTrackerCount(clickBasedlog.leadIds);
            props.setSnackInfo('Modal table refreshed successfully', "success");
        } else {
            props.setSnackInfo('No data to refresh', "info");
        }
    };

    const handleCloseViewMeetingsLogs = () => {
        SetShowMeetingLogs(false)
    }

    const handleDashboardType = (e)=>{
        setMeetingTrackerDashboardType(e.target.value);
    }

        // Trigger download when data is ready
        useEffect(() => {
            if (triggerDownload && meetingTrackerTableCsvData.length > 0) {
                const timer = setTimeout(() => {
                    if (meetingTrackerTableCsvButtonRef.current?.link) {
                        try {
                            meetingTrackerTableCsvButtonRef.current.link.click();
                        } catch (error) {
                            console.error("Error triggering CSV download:", error);
                            props?.setSnackInfo("Error downloading CSV", "error");
                        }
                        setTriggerDownload(false);
                    } else {
                        // Retry if link is not ready
                        setTimeout(() => {
                            if (meetingTrackerTableCsvButtonRef.current?.link) {
                                meetingTrackerTableCsvButtonRef.current.link.click();
                                setTriggerDownload(false);
                            }
                        }, 200);
                    }
                }, 300);
                
                return () => clearTimeout(timer);
            }
        }, [triggerDownload, meetingTrackerTableCsvData]);

    // Trigger monthly table download when data is ready
    useEffect(() => {
        if (triggerMonthlyDownload && meetingTrackerMonthlyTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (meetingTrackerMonthlyTableCsvButtonRef.current?.link) {
                    try {
                        meetingTrackerMonthlyTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerMonthlyDownload(false);
                } else {
                    // Retry if link is not ready
                    setTimeout(() => {
                        if (meetingTrackerMonthlyTableCsvButtonRef.current?.link) {
                            meetingTrackerMonthlyTableCsvButtonRef.current.link.click();
                            setTriggerMonthlyDownload(false);
                        }
                    }, 200);
                }
            }, 300);
            
            return () => clearTimeout(timer);
        }
    }, [triggerMonthlyDownload, meetingTrackerMonthlyTableCsvData]);

    return (
        <div className="App">
            <br />
            <FormControl component="fieldset">
                <RadioGroup
                    aria-label="type"
                    name="type"
                    value={meetingTrackerDashboardType}
                    onChange={(e) => handleDashboardType(e)}
                >
                    <div className="modal-header-radio">
                        <FormControlLabel value="Meeting Done" control={<Radio />} label="Meeting Done" />
                        <FormControlLabel value="Proposed Meeting – Quotation Sent" control={<Radio />} label="Proposed Meeting – Quotation Sent" />
                    </div>
                </RadioGroup>
            </FormControl>
            { meetingTrackerDashboardType === 'Meeting Done' ?
            <div>
            <div>
                <Paper className={classes.paper}>
                    <Grid container spacing={2} justifyContent="center" alignItems="center">
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%' }}>
                                <Autocomplete
                                    multiple
                                    value={selectedLocation}
                                    onChange={handleMultipleLocationData}
                                    options={commonLocation}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Select Location"
                                        variant="outlined"
                                    />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <FormControl style={{ width: '100%'}}>
                                <Autocomplete
                                    multiple
                                    value={selectedExperienceCenter}
                                    onChange={handleMultipleExpData}
                                    options={commonExpCenter}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        label="Select Exp-Center"
                                        variant="outlined"
                                        />
                                    )}
                                    />
                                </FormControl>
                            </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="startDate"
                                name="startDate"
                                label="Meeting Done From Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.startDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                id="endDate"
                                name="endDate"
                                label="Meeting Done End Date"
                                type="date"
                                variant="outlined"
                                value={storeDateFilter.endDate}
                                onChange={storePivotDate}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={12} sm={2}>
                            <Button variant="contained" color="primary" onClick={handlePivotDateFilter} style={{ backgroundColor: "#F50057", color: "#fff", padding: "0.4rem 2rem 2rem 2rem" }} className={classes.submitButton} >
                                Submit
                            </Button>
                        </Grid>
                    </Grid>

                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', marginTop: '30px', flexWrap: 'wrap', gap: '10px' }}>
                        {/* Search Type Dropdown */}
                        <div style={{ width: '20%', position: 'relative' }}>
                            <TextField
                                select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={selectedSearchType}
                                label="Search Type"
                                name="searchType"
                                onChange={(e) => handleSearchType(e.target.value)}
                                variant="outlined"
                                style={{ width: '100%' }}
                                size="small"
                            >
                                {searchTypes && searchTypes?.map((el, index) => (
                                    <MenuItem key={index} value={el}>{el}</MenuItem>
                                ))}
                            </TextField>
                            {/* Fetch New Data Button */}
                            <MuiButton
                                onClick={handleRefreshClick}
                                variant="contained"
                                disabled={isDisabled}
                                size="small"
                                fullWidth
                                style={{ 
                                    backgroundColor: isDisabled ? "#cccccc" : "#F47E46", 
                                    color: "#FFF2EB",
                                    padding: "4px 12px",
                                    marginTop: 8,
                                    fontSize: "0.75rem"
                                }}
                            >
                                {isDisabled 
                                    ? `Wait (${formatTimeLeft()})` 
                                    : "Fetch New Data"}
                            </MuiButton>
                        </div>

                        {/* Search Input */}
                        <TextField
                            label="Enter the input"
                            name="searched"
                            size="small"
                            value={searchInput}
                            onChange={(e) => { setSearchInput(e.target.value) }}
                            onKeyDown={handleKeyDown}  // Listening for the "Enter" key press
                            variant="outlined"
                            style={{ flex: 1, minWidth: '200px' }}
                        />

                           {/* Source of Lead Filter */}
                            <FormControl variant="outlined" size="small" style={{ flex: 1, marginRight: 10, minWidth: '200px' }}>
                                <Autocomplete
                                    multiple
                                    onChange={(e, v) => {
                                        setSelectedLeadSource(v);
                                        setTimeout(() => {
                                            meetingTrackerData(selectedExperienceCenter, selectedUsers, selectedSearchType, searchInput, v,selectedLocation);
                                            DataBasedDateMeetingTracker(storeDateFilter, v,selectedLocation,selectedExperienceCenter);
                                        }, 100);
                                    }}
                                    id="source-of-lead-admin"
                                    options={sourceOfLeadData}
                                    getOptionLabel={(option) => option.name || ''}
                                    filterSelectedOptions
                                    value={selectedLeadSource}
                                    style={{ marginLeft: 10, width: '100%' }}
                                    size='small'
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Source of Lead"
                                            placeholder="Source of Lead"
                                        />
                                    )}
                                />
                            </FormControl>

                        {/* Search Button */}
                        <Button
                            disabled={!selectedSearchType || !searchInput}
                            variant="contained"
                            color="primary"
                            size="medium"
                            style={{marginLeft: 20 }}
                            className={classes.leadSearchButton}
                            onClick={() => handleSearch(searchInput.toUpperCase())}
                        >
                            Search
                        </Button>

                        {/* Clear Filter Button */}
                        <Button
                            variant="contained"
                            color="secondary"
                            size="medium"
                            style={{ marginLeft: 10 }}
                            className={classes.leadClearButton}
                            onClick={clearDateFilter}
                        >
                            Clear Filter
                        </Button>
                    </div>
                </Paper>
            </div>
            <br />
            <div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginTop: '30px' }}>
                    <CSVLink
                        data={meetingTrackerTableCsvData}
                        filename={`Meeting_Tracker_Dashboard_${moment().format('YYYY-MM-DD')}.csv`}
                        ref={meetingTrackerTableCsvButtonRef}
                        style={{ textDecoration: 'none', display: 'none' }}
                    />
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        style={{
                            backgroundColor: "#355025",
                            color: "#FFF2EB",
                            padding: "0.4rem 2rem",
                            border: "none"
                        }}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            
                            // Generate CSV data synchronously to match table structure exactly
                            const csvData = (() => {
                                try {
                                    if (!meetingExpcenter || meetingExpcenter.length === 0 || !meetingDatecount || meetingDatecount.length === 0) {
                                        return [];
                                    }

                                    const csvRows = [];

                                    // Build header row - match table structure exactly
                                    const headerRow = {
                                        "Meeting date": ""
                                    };

                                    // Add meeting date columns
                                    meetingDatecount.forEach((dateEl) => {
                                        if (dateEl.formattedDate) {
                                            headerRow[dateEl.formattedDate] = "";
                                        }
                                    });
                                    headerRow["Total"] = "";
                                    csvRows.push(headerRow);

                                    // Add experience center rows
                                    // Table maps dailyCounts array directly to meetingDatecount array by index
                                    meetingExpcenter.forEach((expCenterEl) => {
                                        const row = {
                                            "Meeting date": expCenterEl.experienceCenterName || ""
                                        };

                                        // Add daily counts - dailyCounts array corresponds to meetingDatecount array by index
                                        meetingDatecount.forEach((dateEl, dateIndex) => {
                                            const dailyCount = expCenterEl.dailyCounts?.[dateIndex];
                                            row[dateEl.formattedDate] = dailyCount?.count || 0;
                                        });

                                        // Add total for this experience center
                                        row["Total"] = expCenterEl.totalCount || 0;
                                        csvRows.push(row);
                                    });

                                    // Add Grand Total row - show all data including grand totals
                                    const grandTotalRow = {
                                        "Meeting date": "Grand Total"
                                    };

                                    // Add grand totals for each meeting date
                                    meetingDatecount.forEach((dateEl) => {
                                        grandTotalRow[dateEl.formattedDate] = dateEl.totalCount || 0;
                                    });

                                    // Add overall grand total in the Total column
                                    grandTotalRow["Total"] = meetingExpcenterGrandTotal || 0;
                                    csvRows.push(grandTotalRow);

                                    return csvRows;
                                } catch (error) {
                                    console.error("Error generating meeting tracker table CSV:", error);
                                    return [];
                                }
                            })();

                            // Set the data and trigger download
                            if (csvData.length > 0) {
                                setMeetingTrackerTableCsvData(csvData);
                                // Use a longer timeout to ensure state is updated
                                setTimeout(() => {
                                    setTriggerDownload(true);
                                }, 100);
                            } else {
                                props?.setSnackInfo("No data available to export", "warning");
                            }
                        }}
                    >
                        Download CSV
                    </Button>
                </div>
            </div>
            <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                        <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                            <Table style={{ minWidth: '600px' }}> {/* Ensure a minimum width for horizontal scrolling */}
                                <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                    <StyledTableRow>
                                        <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold'}}> Meeting date </StyledTableCell>
                                        {meetingDatecount?.map((el, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{
                                                    fontSize:  '13px',
                                                    fontWeight:'bolder',
                                                    textAlign: 'center',
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 1, 
                                                }}
                                            >
                                                    <span style={{ cursor: "pointer" }}>
                                                        {el.formattedDate}
                                                    </span>
                                            </StyledTableCell>
                                        ))}
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", fontWeight: 'bold' , background: '#1C375D', color:'white'}}>
                                           Total
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>

                            {/* Table Body */}
                                <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                    {meetingExpcenter?.map((el, expCenterIndex) => (
                                            <StyledTableRow>
                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 'bold' }}
                                                    // rowSpan={}
                                                >
                                                    {el.experienceCenterName}
                                                </StyledTableCell>
                                                {el.dailyCounts?.map((el, countIndex) => (
                                                  
                                                            <StyledTableCell
                                                                className={classes.bordercolors}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    top: 0,
                                                                    background: 'white',
                                                                    textDecoration:'underline',
                                                                    fontWeight: 'normal',
                                                                    color:'black'
                                                                }}
                                                                onClick={() => getDataBasedClickMeetingTrackerCount(el?.leadIds)}
                                                            >
                                                                {el?.count || "0"}
                                                            </StyledTableCell>     
                                                ))} 
                                                <StyledTableCell
                                                                className={classes.bordercolors}
                                                                style={{ position: 'sticky', left: 0, textAlign: "center", background:'#1C375D',fontWeight:'bolder',cursor: "pointer",textDecoration:'underline', color:'white'}}
                                                                onClick={() => getDataBasedClickMeetingTrackerCount(el?.allLeadIds)}
                                                            >
                                                               {el?.totalCount || "0"}
                                                </StyledTableCell>
                                            </StyledTableRow>  
                                    ))}

                                    <StyledTableRow>
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold' }}
                                            rowSpan={1}
                                        >
                                            Grand Total
                                        </StyledTableCell>
                                      

                                        {meetingDatecount?.map((el, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{ textAlign: "center", cursor: "pointer", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "#1C375D", color:'white' }}
                                                onClick={() => getDataBasedClickMeetingTrackerCount(el?.leadIds)}
                                            >
                                                {el.totalCount}
                                            </StyledTableCell>
                                        ))}
                                         <StyledTableCell
                                            className={classes.bordercolors}
                                            style={{ textAlign: "center", cursor: "pointer", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "#1C375D", color:'white' }}
                                            onClick={() => getDataBasedClickMeetingTrackerCount(meetingExpcenterGrandTotalLeadId)}
                                        >
                                            {meetingExpcenterGrandTotal}
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>
                            </Table>
                        </TableContainer>
                    </div>
                    <br/>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginTop: '30px' }}>
                            <CSVLink
                                data={meetingTrackerMonthlyTableCsvData}
                                filename={`Meeting_Tracker_Monthly_Dashboard_${moment().format('YYYY-MM-DD')}.csv`}
                                ref={meetingTrackerMonthlyTableCsvButtonRef}
                                style={{ textDecoration: 'none', display: 'none' }}
                            />
                            <Button
                                type="primary"
                                icon={<DownloadOutlined />}
                                style={{
                                    backgroundColor: "#355025",
                                    color: "#FFF2EB",
                                    padding: "0.4rem 2rem",
                                    border: "none"
                                }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    
                                    // Generate CSV data synchronously to match table structure exactly
                                    const csvData = (() => {
                                        try {
                                            if (!store || store.length === 0 || !store[0]?.monthlyGrandTotal || store[0].monthlyGrandTotal.length === 0) {
                                                return [];
                                            }

                                            // Use the EXACT same data structures as the table uses
                                            const localExpCenterData = {};
                                            store.forEach((el) => {
                                                if (!localExpCenterData[el.experienceCenterName]) {
                                                    localExpCenterData[el.experienceCenterName] = [];
                                                }
                                                localExpCenterData[el.experienceCenterName].push(el);
                                            });

                                            const localUniqueexperienceCenterNames = Array.from(new Set(store.map((el) => el.experienceCenterName)));
                                            const localUniqueexperienceCenterCode = Array.from(new Set(store.map((el) => el.expCenterCode)));

                                            if (localUniqueexperienceCenterNames.length === 0) {
                                                return [];
                                            }

                                            const csvRows = [];

                                            // Build header row - match table structure exactly
                                            const headerRow = {
                                                "Months": "",
                                                "Particulars": ""
                                            };

                                            // Build header columns to match data row structure exactly
                                            // Data rows iterate: uniqueexperienceCenterNames -> expCenterData[experienceCenterName] -> innerEl
                                            const headerColumns = [];
                                            localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                                                if (localExpCenterData[experienceCenterName]) {
                                                    localExpCenterData[experienceCenterName].forEach((innerEl) => {
                                                        if (innerEl.expCenterCode) {
                                                            headerColumns.push(innerEl.expCenterCode);
                                                        }
                                                    });
                                                }
                                            });
                                            
                                            headerColumns.forEach((expCenterCode) => {
                                                if (expCenterCode) {
                                                    headerRow[expCenterCode] = "";
                                                }
                                            });
                                            headerRow["Total"] = "";
                                            csvRows.push(headerRow);

                                            // Add monthly data rows
                                            store[0].monthlyGrandTotal.forEach((month) => {
                                                // Row 1: Total No. of Leads with Meeting
                                                const row1 = {
                                                    "Months": `${month?.monthName?.slice(0, 3)}-${month?.year % 100}`,
                                                    "Particulars": "Total No. of Leads with Meeting"
                                                };

                                                localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                                                    if (localExpCenterData[experienceCenterName]) {
                                                        localExpCenterData[experienceCenterName].forEach((innerEl) => {
                                                            if (innerEl.expCenterCode) {
                                                                const monthlyData = innerEl.monthlyGrandTotal?.find(
                                                                    (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                );
                                                                row1[innerEl.expCenterCode] = formatNumberToTwoDecimalPlaces(monthlyData?.meetingCount || 0);
                                                            }
                                                        });
                                                    }
                                                });

                                                // Grand Total for row 1 - sum of all displayed cells
                                                const row1GrandTotal = Object.keys(row1).reduce((sum, key) => {
                                                    return (key !== "Months" && key !== "Particulars" && key !== "Total") ? sum + (parseFloat(row1[key]) || 0) : sum;
                                                }, 0);
                                                row1["Total"] = formatNumberToTwoDecimalPlaces(row1GrandTotal);
                                                csvRows.push(row1);

                                                // Row 2: Total No. of Leads with Won Meeting
                                                const row2 = {
                                                    "Months": "",
                                                    "Particulars": "Total No. of Leads with Won Meeting"
                                                };

                                                localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                                                    if (localExpCenterData[experienceCenterName]) {
                                                        localExpCenterData[experienceCenterName].forEach((innerEl) => {
                                                            if (innerEl.expCenterCode) {
                                                                const monthlyData = innerEl.monthlyGrandTotal?.find(
                                                                    (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                );
                                                                row2[innerEl.expCenterCode] = formatNumberToTwoDecimalPlaces(monthlyData?.wonMeetingCount || 0);
                                                            }
                                                        });
                                                    }
                                                });

                                                // Grand Total for row 2
                                                const row2GrandTotal = Object.keys(row2).reduce((sum, key) => {
                                                    return (key !== "Months" && key !== "Particulars" && key !== "Total") ? sum + (parseFloat(row2[key]) || 0) : sum;
                                                }, 0);
                                                row2["Total"] = formatNumberToTwoDecimalPlaces(row2GrandTotal);
                                                csvRows.push(row2);

                                                // Row 3: Total No. of Leads with Neither Won Nor Lost Meeting
                                                const row3 = {
                                                    "Months": "",
                                                    "Particulars": "Total No. of Leads with Neither Won Nor Lost Meeting"
                                                };

                                                localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                                                    if (localExpCenterData[experienceCenterName]) {
                                                        localExpCenterData[experienceCenterName].forEach((innerEl) => {
                                                            if (innerEl.expCenterCode) {
                                                                const monthlyData = innerEl.monthlyGrandTotal?.find(
                                                                    (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                );
                                                                row3[innerEl.expCenterCode] = formatNumberToTwoDecimalPlaces(monthlyData?.notWonNotLostMeetingCount || 0);
                                                            }
                                                        });
                                                    }
                                                });

                                                // Grand Total for row 3
                                                const row3GrandTotal = Object.keys(row3).reduce((sum, key) => {
                                                    return (key !== "Months" && key !== "Particulars" && key !== "Total") ? sum + (parseFloat(row3[key]) || 0) : sum;
                                                }, 0);
                                                row3["Total"] = formatNumberToTwoDecimalPlaces(row3GrandTotal);
                                                csvRows.push(row3);
                                            });

                                            // Add Grand Total rows
                                            // Row 1: Total No. of Leads with Meeting
                                            const grandTotalRow1 = {
                                                "Months": "Grand Total",
                                                "Particulars": "Total No. of Leads with Meeting"
                                            };

                                            localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                                                const total = store.reduce((sum, el) => 
                                                    sum + (el.experienceCenterName === experienceCenterName ? (el.meetingCount || 0) : 0), 0
                                                );
                                                // For Grand Total, we need to sum by experienceCenterName (not expCenterCode)
                                                // But CSV columns are by expCenterCode, so we need to distribute the total
                                                // Actually, looking at the table, it shows per experienceCenterName in Grand Total
                                                // But CSV columns are by expCenterCode, so we need to handle this
                                                // Let's sum all expCenterCodes that belong to this experienceCenterName
                                                let expCenterTotal = 0;
                                                if (localExpCenterData[experienceCenterName]) {
                                                    localExpCenterData[experienceCenterName].forEach((innerEl) => {
                                                        if (innerEl.expCenterCode) {
                                                            expCenterTotal += store.reduce((sum, el) => 
                                                                sum + (el.expCenterCode === innerEl.expCenterCode ? (el.meetingCount || 0) : 0), 0
                                                            );
                                                        }
                                                    });
                                                }
                                                // Since we have multiple expCenterCodes per experienceCenterName, we need to set each one
                                                if (localExpCenterData[experienceCenterName]) {
                                                    localExpCenterData[experienceCenterName].forEach((innerEl) => {
                                                        if (innerEl.expCenterCode) {
                                                            grandTotalRow1[innerEl.expCenterCode] = formatNumberToTwoDecimalPlaces(
                                                                store.reduce((sum, el) => 
                                                                    sum + (el.expCenterCode === innerEl.expCenterCode ? (el.meetingCount || 0) : 0), 0
                                                                )
                                                            );
                                                        }
                                                    });
                                                }
                                            });

                                            // Grand Total for grand total row 1
                                            const grandTotalRow1Total = Object.keys(grandTotalRow1).reduce((sum, key) => {
                                                return (key !== "Months" && key !== "Particulars" && key !== "Total") ? sum + (parseFloat(grandTotalRow1[key]) || 0) : sum;
                                            }, 0);
                                            grandTotalRow1["Total"] = formatNumberToTwoDecimalPlaces(grandTotalRow1Total);
                                            csvRows.push(grandTotalRow1);

                                            // Row 2: Total No. of Leads with Won Meeting
                                            const grandTotalRow2 = {
                                                "Months": "",
                                                "Particulars": "Total No. of Leads with Won Meeting"
                                            };

                                            localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                                                if (localExpCenterData[experienceCenterName]) {
                                                    localExpCenterData[experienceCenterName].forEach((innerEl) => {
                                                        if (innerEl.expCenterCode) {
                                                            grandTotalRow2[innerEl.expCenterCode] = formatNumberToTwoDecimalPlaces(
                                                                store.reduce((sum, el) => 
                                                                    sum + (el.expCenterCode === innerEl.expCenterCode ? (el.wonMeetingCount || 0) : 0), 0
                                                                )
                                                            );
                                                        }
                                                    });
                                                }
                                            });

                                            const grandTotalRow2Total = Object.keys(grandTotalRow2).reduce((sum, key) => {
                                                return (key !== "Months" && key !== "Particulars" && key !== "Total") ? sum + (parseFloat(grandTotalRow2[key]) || 0) : sum;
                                            }, 0);
                                            grandTotalRow2["Total"] = formatNumberToTwoDecimalPlaces(grandTotalRow2Total);
                                            csvRows.push(grandTotalRow2);

                                            // Row 3: Total No. of Leads with Neither Won Nor Lost Meetings
                                            const grandTotalRow3 = {
                                                "Months": "",
                                                "Particulars": "Total No. of Leads with Neither Won Nor Lost Meetings"
                                            };

                                            localUniqueexperienceCenterNames.forEach((experienceCenterName) => {
                                                if (localExpCenterData[experienceCenterName]) {
                                                    localExpCenterData[experienceCenterName].forEach((innerEl) => {
                                                        if (innerEl.expCenterCode) {
                                                            grandTotalRow3[innerEl.expCenterCode] = formatNumberToTwoDecimalPlaces(
                                                                store.reduce((sum, el) => 
                                                                    sum + (el.expCenterCode === innerEl.expCenterCode ? (el.notWonNotLostMeetingCount || 0) : 0), 0
                                                                )
                                                            );
                                                        }
                                                    });
                                                }
                                            });

                                            const grandTotalRow3Total = Object.keys(grandTotalRow3).reduce((sum, key) => {
                                                return (key !== "Months" && key !== "Particulars" && key !== "Total") ? sum + (parseFloat(grandTotalRow3[key]) || 0) : sum;
                                            }, 0);
                                            grandTotalRow3["Total"] = formatNumberToTwoDecimalPlaces(grandTotalRow3Total);
                                            csvRows.push(grandTotalRow3);

                                            return csvRows;
                                        } catch (error) {
                                            console.error("Error generating meeting tracker monthly table CSV:", error);
                                            return [];
                                        }
                                    })();

                                    // Set the data and trigger download
                                    if (csvData.length > 0) {
                                        setMeetingTrackerMonthlyTableCsvData(csvData);
                                        setTimeout(() => {
                                            setTriggerMonthlyDownload(true);
                                        }, 100);
                                    } else {
                                        props?.setSnackInfo("No data available to export", "warning");
                                    }
                                }}
                            >
                                Download CSV
                            </Button>
                        </div>
                    </div>
                    <div style={{ maxHeight: '500px', overflow: 'auto' }}>
                        <TableContainer component={Paper} classes={{ root: classes.customTableContainer }} style={{ marginTop: '30px' }}>
                            <Table style={{ minWidth: '600px' }}> {/* Ensure a minimum width for horizontal scrolling */}
                                <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, background: 'white' }}>
                                    <StyledTableRow>
                                        <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold'}}> Months </StyledTableCell>
                                        <StyledTableCell className={classes.bordercolors} style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold'}}> Particulars </StyledTableCell>
                                        {store.slice(0, uniqueexperienceCenterCode.length - 1).map((experienceCenterName, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{
                                                    fontSize: index === uniqueexperienceCenterNames.length - 1 ? '15px' : '13px',
                                                    fontWeight:'bolder',
                                                    textAlign: 'center',
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 1, 
                                                }}
                                            >
                                                <Tooltip title={`${experienceCenterName.experienceCenterName}-${experienceCenterName.expCtrCityName}`} placement="top">
                                                    <span style={{ cursor: "pointer" }}>
                                                        {experienceCenterName.expCenterCode}
                                                    </span>
                                                </Tooltip>
                                            </StyledTableCell>
                                        ))}
                                        <StyledTableCell className={classes.bordercolors} style={{ textAlign: "center", fontWeight: 'bold' , background: '#1C375D', color:'white'}}>
                                           Total
                                        </StyledTableCell>
                                    </StyledTableRow>
                                </TableHead>

                            {/* Table Body */}
                                <TableHead style={{ position: 'sticky', top: 0, background: 'white' }}>
                                    {store[0]?.monthlyGrandTotal?.map((month, monthIndex) => (
                                        <React.Fragment key={monthIndex}>
                                            <StyledTableRow>
                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", fontWeight: 'bold' }}
                                                    rowSpan={3}
                                                >
                                                    {`${month?.monthName?.slice(0, 3)}-${month?.year % 100}`}
                                                </StyledTableCell>
                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", background: 'white', color:'black'}}
                                                >
                                                    Total No. of Leads with Meeting
                                                </StyledTableCell>

                                                {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                    <React.Fragment key={expCenterIndex}>
                                                        {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <StyledTableCell
                                                                className={classes.bordercolors}
                                                                key={dataIndex}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    top: 0,
                                                                    background: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? '#1C375D' : 'white',
                                                                    color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'white' : 'black',
                                                                    textDecoration:'underline',
                                                                    fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, month, innerEl, 'meetingTracker','NoOfMeeting')}
                                                            >
                                                                {formatNumberToTwoDecimalPlaces(
                                                                    innerEl.monthlyGrandTotal.find(
                                                                        (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                    )?.meetingCount || 0
                                                                )}
                                                            </StyledTableCell>
                                                        ))}
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>

                                            <StyledTableRow>
                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", background:'white', color: 'black'}}
                                                >
                                                    Total No. of Leads with Won Meeting
                                                </StyledTableCell>
                                                {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                    <React.Fragment key={expCenterIndex}>
                                                        {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <StyledTableCell
                                                                className={classes.bordercolors}
                                                                key={dataIndex}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    top: 0,
                                                                    textDecoration:'underline',
                                                                    background: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? '#1C375D' : 'white',
                                                                    color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'white' : 'black',
                                                                    fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, month, innerEl, 'meetingTracker', 'WonFromMeeting')}
                                                            >
                                                                {formatNumberToTwoDecimalPlaces(
                                                                    innerEl.monthlyGrandTotal.find(
                                                                        (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                    )?.wonMeetingCount || 0
                                                                )}
                                                            </StyledTableCell>
                                                        ))}
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>

                                            <StyledTableRow>
                                                <StyledTableCell
                                                    className={classes.bordercolors}
                                                    style={{ position: 'sticky', left: 0, textAlign: "center", background:'white', color: 'black' }}
                                                >
                                                   Total No. of Leads with Neither Won Nor Lost Meeting
                                                </StyledTableCell>
                                                {uniqueexperienceCenterNames.map((experienceCenterName, expCenterIndex) => (
                                                    <React.Fragment key={expCenterIndex}>
                                                        {expCenterData[experienceCenterName].map((innerEl, dataIndex) => (
                                                            <StyledTableCell
                                                                className={classes.bordercolors}
                                                                key={dataIndex}
                                                                style={{
                                                                    textAlign: "center",
                                                                    cursor: "pointer",
                                                                    top: 0,
                                                                    textDecoration:'underline',
                                                                    background: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? '#1C375D' : 'white',
                                                                    color: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'white' : 'black',
                                                                    fontWeight: expCenterIndex === uniqueexperienceCenterNames.length - 1 ? 'bolder' : 'normal',
                                                                }}
                                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, month, innerEl, 'meetingTracker', 'NotWonNotLost')}
                                                            >
                                                                {formatNumberToTwoDecimalPlaces(
                                                                    innerEl.monthlyGrandTotal.find(
                                                                        (entry) => entry.monthName === month.monthName && entry.year === month.year
                                                                    )?.notWonNotLostMeetingCount || 0
                                                                )}
                                                            </StyledTableCell>
                                                        ))}
                                                    </React.Fragment>
                                                ))}
                                            </StyledTableRow>
                                        </React.Fragment>
                                    ))}

                                    <StyledTableRow>
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", fontWeight: 'bold' }}
                                            rowSpan={3}
                                        >
                                            Grand Total
                                        </StyledTableCell>
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center", background: '#1C375D', color: 'white'}}
                                        >
                                            Total No. of Leads with Meeting
                                        </StyledTableCell>

                                        {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{ textAlign: "center", cursor: "pointer", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "#1C375D", color:'white' }}
                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, store[0].monthlyGrandTotal, experienceCenterName, 'total', 'NoOfMeeting')}
                                            >
                                                {formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.meetingCount : 0), 0))}
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                    {/* 2nd  */}
                                    <StyledTableRow>
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}
                                        >
                                            Total No. of Leads with Won Meeting
                                        </StyledTableCell>

                                        {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{ textAlign: "center", cursor: "pointer", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "#1C375D", color: 'white' }}
                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, store[0].monthlyGrandTotal, experienceCenterName, 'total', 'WonFromMeeting')}
                                            >
                                                {formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.wonMeetingCount : 0), 0))}
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                    {/* 3rd */}
                                    <StyledTableRow>
                                        <StyledTableCell
                                            className={classes.bordercolors}
                                            style={{ position: 'sticky', left: 0, zIndex: 9, textAlign: "center" }}
                                        >
                                           Total No. of Leads with Neither Won Nor Lost Meetings
                                        </StyledTableCell>

                                        {uniqueexperienceCenterNames.map((experienceCenterName, index) => (
                                            <StyledTableCell
                                                className={classes.bordercolors}
                                                key={index}
                                                style={{ textAlign: "center", cursor: "pointer", zIndex: 1, textDecoration: "underline", fontWeight: 'bolder', background: "#1C375D", color:'white' }}
                                                onClick={(e) => getDataBasedOnClickMeetingTracker(e, store[0].monthlyGrandTotal, experienceCenterName, 'total', 'NotWonNotLost')}
                                            >
                                                {formatNumberToTwoDecimalPlaces(store.reduce((total, el) => total + (el.experienceCenterName === experienceCenterName ? el.notWonNotLostMeetingCount : 0), 0))}
                                            </StyledTableCell>
                                        ))}
                                    </StyledTableRow>
                                </TableHead>
                            </Table>
                        </TableContainer>
                    </div>
            <Modal
                title='Meeting Tracker'
                centered
                visible={showDetailedModal}
                onCancel={() => setShowDetailedModal(false)}
                width={1000}
                maskClosable={true}
                footer={null}
                zIndex={5000}
            >
                <div className={classes.csv}>
                    <CSVLink
                        headers={headers}
                        filename='meetingTracker.csv'
                        data={csvData}
                        ref={csvButtonRef}
                    />
                    <Button
                        onClick={() => csvDownloadHandler(popMonthData)}
                        style={{ backgroundColor: "#355025",color:"#FFF2EB" }}
                        variant="contained"
                        color="secondary"
                    >
                        Download CSV
                    </Button>
                </div>
                {popMonthData && (
                    <TableContainer component={Paper} className={classes.table}>
                        <Table
                            style={{ width: 500 }}
                            className={classes.table}
                            stickyHeader
                            aria-label="sticky table"
                        >
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell>Sl. No.</StyledTableCell>
                                    <StyledTableCell>Project No.</StyledTableCell>
                                    <StyledTableCell>Lead No.</StyledTableCell>
                                    <StyledTableCell>Client Name</StyledTableCell>
                                    <StyledTableCell>Source of Lead</StyledTableCell>
                                    <StyledTableCell>Exp. Ctr. Name</StyledTableCell>
                                    <StyledTableCell>Current Stage</StyledTableCell>
                                    <StyledTableCell>Sales Won Date</StyledTableCell>
                                    <StyledTableCell>Meeting Date</StyledTableCell>
                                    <StyledTableCell>Lead Created Date</StyledTableCell>
                                    <StyledTableCell>Lead Assigned Date</StyledTableCell>
                                    <StyledTableCell>Sales Executive</StyledTableCell>
                                    <StyledTableCell>ASM</StyledTableCell>
                                    <StyledTableCell>Latest Notes</StyledTableCell>
                                    <StyledTableCell>Meeting Logs</StyledTableCell>
                                    <StyledTableCell>Total Count Quotation Open by Cx</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {popMonthData?.map((data, i) => {
                                    return (
                                        <StyledTableRow key={i}>
                                        {/* Serial No */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {i + 1}
                                        </StyledTableCell>
                                  
                                        {/* Project No */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.erpProjectNo || data?.erpProjectNo ? (
                                            <Link
                                              to={`/project-logs/${data?.leadId?._id || data?._id}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{ color: "#000", textDecoration: "underline" }}
                                            >
                                              {data?.leadId?.erpProjectNo || data?.erpProjectNo}
                                            </Link>
                                          ) : (
                                            "NA"
                                          )}
                                        </StyledTableCell>
                                  
                                        {/* Lead No */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.lead_no || data?.lead_no ? (
                                            <Link
                                              to={`/project-logs/${data?.leadId?._id || data?._id}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              style={{ color: "#000", textDecoration: "underline" }}
                                            >
                                              {data?.leadId?.lead_no || data?.lead_no}
                                            </Link>
                                          ) : (
                                            "NA"
                                          )}
                                        </StyledTableCell>
                                  
                                        {/* Customer */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.customerId?.name || data?.customerId?.name || "NA"}
                                        </StyledTableCell>

                                        {/* Source of Lead */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.sourceOfLead?.name || data?.sourceOfLead?.name || "NA"}
                                        </StyledTableCell>
                                  
                                        {/* Experience Center */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.experienceCenterId?.name || data?.experienceCenterId?.name || "NA"}
                                        </StyledTableCell>
                                  
                                        {/* Current Stage */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.currentStage || data?.currentStage || "-"}
                                        </StyledTableCell>
                                  
                                        {/* Lead Won Date */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.leadWonDate || data?.leadWonDate
                                            ? moment(data?.leadId?.leadWonDate || data?.leadWonDate).format("DD-MM-YYYY")
                                            : "-"}
                                        </StyledTableCell>
                                  
                                        {/* Meeting Date */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {moment(data?.meetingDate).format("DD-MM-YYYY") || '-'}
                                        </StyledTableCell>
                                  
                                        {/* Created At */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {moment(data?.leadId?.createdAt || data?.createdAt).format("DD-MM-YYYY")}
                                        </StyledTableCell>

                                        {/* Lead Assigned Date */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.leadAssignedDate || data?.leadAssignedDate
                                            ? moment(data?.leadId?.leadAssignedDate || data?.leadAssignedDate).format("DD-MM-YYYY")
                                            : "-"}
                                        </StyledTableCell>

                                        {/* Sales User */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.salesUser?.name || data?.salesUser?.name || "NA"}
                                        </StyledTableCell>
                                  
                                        {/* Sales Assistant Manager */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.salesAssistantManager?.name ||
                                            data?.salesAssistantManager?.name ||
                                            "NA"}
                                        </StyledTableCell>
                                  
                                        {/* Notes Icon */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          <EyeFilled
                                            style={{ cursor: "pointer", fontSize: "20px", color: "#1890ff" }}
                                            onClick={() =>
                                              handleViewNotes(
                                                data?.recentNotes || data?.leadId?.recentNotes,
                                                data?.leadId?.lead_no || data?.lead_no
                                              )
                                            }
                                          />
                                        </StyledTableCell>
                                  
                                        {/* Meeting Logs Count */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          <span
                                            onClick={() => handleOpenViewMeetingsLogs(data || data)}
                                            style={{
                                              color: "#000",
                                              textDecoration: "underline",
                                              textAlign: "center",
                                              cursor: "pointer",
                                            }}
                                          >
                                            {data?.leadId?.meetingLogsCount || data?.meetingLogsCount || "NA"}
                                          </span>
                                        </StyledTableCell>
                                        {/* Total Open Count by Cx */}
                                        <StyledTableCell component="th" style={{ textAlign: "center", fontWeight: "normal" }}>
                                          {data?.leadId?.quotationOpenCount ?? data?.quotationOpenCount ?? 0}
                                        </StyledTableCell>
                                      </StyledTableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Modal>
            <div>
                <Dialog
                    open={notesVisibility}
                    onClose={() => setNotesVisibility(false)}
                    style={{ zIndex: 10000 }} 
                >
                    <DialogTitle>
                        {`Notes of the lead no - ${leadNo || "NA"}`}
                        <IconButton
                            aria-label="close"
                            onClick={() => setNotesVisibility(false)}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        {latestNotes && latestNotes.length > 0 ? (
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHeaderCell}><b>Sl. No</b></TableCell>
                                            <TableCell className={classes.tableHeaderCell}><b>Notes</b></TableCell>
                                            <TableCell className={classes.tableHeaderCell}><b>Created At</b></TableCell>
                                            <TableCell className={classes.tableHeaderCell}><b>User</b></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {latestNotes.map((note, index) => (
                                            <TableRow key={index}>
                                                <TableCell>{index + 1}</TableCell>
                                                <TableCell>{note?.notes}</TableCell>
                                                <TableCell>{moment(note?.createdAt).format('DD-MM-YYYY')}</TableCell>
                                                <TableCell>{note?.user?.name || "NA"}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        ) : (
                            <p>No notes available.</p>
                        )}
                    </DialogContent>
                </Dialog>
            </div> 

           {/* Meeting Logs display */}
            <div>
                <Dialog  maxWidth="md" fullWidth open={showMeetingLogs} onClose={handleCloseViewMeetingsLogs}   style={{ zIndex: 10000 }}  >
                    <DialogTitle style={{ textAlign: "left", }} >Meeting Logs</DialogTitle>
                    <DialogContent>
                        <Box>
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell component="th" style={{ fontWeight: "600" }} >Sl.No</TableCell>
                                            <TableCell component="th" style={{ fontWeight: "600" }} >Created Date</TableCell>
                                            <TableCell component="th" style={{ fontWeight: "600" }} >Stage</TableCell>
                                            <TableCell component="th" style={{ fontWeight: "600" }} >Meeting Date</TableCell>
                                            <TableCell component="th" style={{ fontWeight: "600" }} >Meeting Type</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {meetingLogs?.map((log, index) => (
                                            <TableRow key={index}>
                                                <TableCell component="th">{index + 1}</TableCell>
                                                <TableCell component="th">
                                                    {new Date(log?.createdAt).toLocaleDateString()}
                                                </TableCell>
                                                <TableCell component="th">
                                                    {log?.meetingStage || 'Designer Assignment Pending'}
                                                </TableCell>
                                                <TableCell component="th">
                                                    {log?.meetingDate ?
                                                        new Date(new Date(log?.meetingDate).getTime() + (5 * 60 + 30) * 60 * 1000).toLocaleDateString()
                                                        : '-'}
                                                </TableCell>

                                                <TableCell component="th">
                                                    {log?.meetingTypes?.officeMeets?.length > 0 ? 'Office Meet' :
                                                        log?.meetingTypes?.residenceMeets?.length > 0 ? 'Residence Meet' : ''}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        {meetingLogs?.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={4} align="center">
                                                    No meetings found
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseViewMeetingsLogs}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
            </div>
            : 
            <ProposedMeetingPage/>
            }
        </div >
    );
}

export default connect(null, { setLoading, setSnackInfo })(MeetingTrackerDashboard);